// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"422":"49731289","794":"92d5238b"}[chunkId] + ".css";
};